module.exports = __webpack_public_path__ + "img/Dr-Jennell-Giles.620a74fd.png";